var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"dj-container"},[_c('el-header',{staticClass:"dj-container__header",attrs:{"height":"auto"}},[_vm._t("header")],2),_c('el-main',{staticClass:"dj-container__main"},[_vm._t("default")],2),_c('el-footer',{staticClass:"dj-container__footer",attrs:{"height":"auto"}},[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }